import { useTranslation } from 'react-i18next'
import LoadingIndicator from '@/widgets/LoadingIndicator'
import Certificates from '@/pages/centrumSzkolen/common/Certificates'
import DateAndLocation from './DateAndLocation'
import MyTrainingDetailsCard from './MyTrainingDetailsCard'
import MyTrainingProofFilesSection from './MyTrainingProofFilesSection'
import MyTrainingTrainersSection from './MyTrainingTrainersSection'
import Remarks from './Remarks'
import useMyTrainingDetailsPage from './hooks/useMyTrainingDetailsPage'

export default function MyTrainingDetails() {
	const { t } = useTranslation()
	const {
		certificationNames,
		createdDate,
		currentTrainer,
		currentTrainerName,
		loading,
		statusLabel,
		trainerRows,
		training,
		uploadTrainingFile,
		downloadTrainingFile,
		deleteTrainingFile,
	} = useMyTrainingDetailsPage()

	if (loading) {
		return <LoadingIndicator message={t('myTrainings.details.loading')} />
	}

	if (!training) {
		return <div className="min-h-screen flex items-center justify-center">{t('myTrainings.details.noData')}</div>
	}

	return (
		<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
			<MyTrainingDetailsCard
				training={training}
				statusLabel={statusLabel}
				createdDate={createdDate}
			/>

			<div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
				<DateAndLocation training={training} />
				<Certificates certificationNames={certificationNames} />
			</div>

			<div className="mt-6 grid grid-cols-1 gap-6 xl:grid-cols-2">
				<MyTrainingTrainersSection
					trainerRows={trainerRows}
					currentTrainerName={currentTrainerName}
				/>

				<Remarks remarks={training.remarks} />
			</div>

			<MyTrainingProofFilesSection
				training={training}
				currentTrainer={currentTrainer}
				onUploadTrainingFile={uploadTrainingFile}
				onDownloadTrainingFile={downloadTrainingFile}
				onDeleteTrainingFile={deleteTrainingFile}
			/>
		</div>
	)
}
